<template>
   <tool-select-wrapper
      label="MHP"
      icon-url="/static/icons/tools/pin.svg"
      :selected="mhpIsSelected"
      @click="handleClick">
      <tool-select-item :tool="mhpTool" @click="handleMhpToolSelect"/>

      <el-dialog class="mhp-dialog" title="MHP Form" :visible="showMhpDialog" modal-append-to-body append-to-body>
         <form @submit.prevent="handleMHPFromSubmit">
            <input-field
               label="Power (kW)"
               placeholder="Power (kW)"
               type="number"
               :extra-attributes="{step: 0.001, min: 0.001}"
               v-model="form.power_kW"
               :errors="[]"
               required
               one-line
               label50
            />
            <input-field
               label="MHP Interval (kW)"
               placeholder="MHP Interval (kW)"
               type="number"
               :extra-attributes="{step: 0.001, min: 0.001}"
               v-model="form.mhp_interval"
               :errors="[]"
               required
               one-line
               label50
            />
            <input-field
               label="Discharge (m3/s)"
               placeholder="Discharge (m3/s)"
               type="number"
               :extra-attributes="{step: 0.001, min: 0.001}"
               v-model="form.discharge"
               :errors="[]"
               required
               one-line
               label50
            />
            <span slot="footer" class="dialog-footer">
               <atom-button @click="showMhpDialog = false">Cancel</atom-button>
               <atom-button type="submit" color="primary">Confirm</atom-button>
            </span>
         </form>
      </el-dialog>
   </tool-select-wrapper>
</template>

<script>
import ToolSelectItem from '../MapToolSelectItem';
import ToolSelectWrapper from '../ToolSelectWrapper';
import InputField from '@/components/molecules/Login/InputField';
import AtomButton from '@/components/atoms/Login/Button';
import { Dialog } from 'element-ui';
import { bus } from '@/main';
import { mapGetters, mapActions } from 'vuex';
import { MHP } from '@/store/modules/tools';
import { handleToolModeSelection,selectMhpTool } from '@/js/tools/mhp';

const mhpTool = {
   id: 'mhp-tool',
   title: 'SELECT ONE STREAM',
   iconURL: '/icons/tools/location.svg',
   description: 'Select one stream to process for identification of possible locations of potential MHP.',
};

export default {
   components: {
      ToolSelectItem,
      ToolSelectWrapper,
      InputField,
      AtomButton,
      'el-dialog': Dialog,
   },
   computed: mapGetters("tools", ["mhpIsSelected"]),
   created()
   {
      bus.$on('stream-selected', ({dam_pt_approx, arc_id, discharge}) =>
      {
         this.form.dam_pt_approx = dam_pt_approx;
         this.form.arc_id = arc_id;
         this.form.discharge = discharge;
         this.showMhpDialog = true;
      });
      handleToolModeSelection(this.mhpIsSelected);
   },
   beforeDestroy()
   {
      handleToolModeSelection(false);
      this.clearResults({mhp: true});
   },
   data()
   {
      return {
         mhpTool,
         showMhpDialog: false,
         form: {
            power_kW: 5,
            mhp_interval: 5,
            discharge: 0.02,
            dam_pt_approx: '',
            arc_id: '',
         },
         formLabelWidth: '120px'
      };
   },
   watch: {
      mhpIsSelected(isSelected) {
         handleToolModeSelection(isSelected);
      }
   },
   methods: {
      ...mapActions('tools', ['setCurrentTool', 'performMhpAnalysis', "clearResults"]),
      handleClick()
      {
         this.setCurrentTool(MHP);
      },
      handleMhpToolSelect()
      {
         selectMhpTool();
      },
      handleMHPFromSubmit()
      {
         this.performMhpAnalysis(this.form);
         this.showMhpDialog = false;
      }
   }
}
</script>

<style lang="scss" scoped>
.mhp-dialog {
   font-family: $primary-font;
}
form {
   padding: 0 1em 1em 1em;
   font-size: 1rem;
   .dialog-footer {
      display: flex;
      justify-content: flex-end;
      button {
         margin: 0.4em;
      }
   }
}
</style>
